<template>
  <router-view />
  <button
    v-if="
      store.getters?.getRoleLevel?.toLowerCase() == 'admin' &&
      store.getters.isAuthenticated
    "
    @click="openChatBot = true"
    class="hidden fixed right-5 bottom-5 flex items-center justify-center  transition-all duration-300 ease-in-out"
    :class="[
      !openChatBot
        ? 'h-14 w-14 opacity-1 bg_primary rounded-full'
        : 'opacity-0 w-[450px] bg-white md:h-[85vh] 2xl:h-[70vh] rounded-2xl',
    ]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      class="size-7 text-white"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
      />
    </svg>
  </button>
  <div
    class="fixed z-[999] bottom-5 right-5 transition-all duration-300 ease-in-out bg-white shadow-2xl rounded-2xl flex flex-col overflow-hidden"
    :class="[
      openChatBot
        ? 'opacity-1 w-[450px] md:h-[85vh] 2xl:h-[70vh]'
        : 'opacity-0 w-0 h-0',
    ]"
  >
    <div
      class="bg_primary text-white p-4 font-semibold flex items-center justify-between"
    >
      <span>CRM AI</span>
      <svg
        @click="openChatBot = false"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        class="size-6 text-white cursor-pointer"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18 18 6M6 6l12 12"
        />
      </svg>
    </div>

    <!-- Messages -->
    <div
      ref="chatBox"
      class="flex-1 w-full overflow-y-auto p-3 space-y-2 bg-gray-50"
    >
      <div
        v-for="(suggestion, index) in suggestions"
        :key="index"
        class="flex justify-start"
      >
        <div
          @click="handleSuggestionClick(suggestion)"
          :class="[
            'inline-block px-3 py-2 rounded-lg text-sm w-fit text-left bg-white hover:border-blue-600 cursor-pointer text-black border border-blue-400',
          ]"
        >
          {{ suggestion }}
        </div>
      </div>
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="
          msg.type === 'user'
            ? 'flex  justify-end'
            : 'flex flex-col items-start'
        "
      >
        <div
          :class="[
            'inline-block px-3 py-2  text-sm max-w-[98%] text-left text-wrap',
            msg.type === 'user'
              ? 'bg-blue-500 text-white rounded-l-lg rounded-br-lg'
              : 'bg-white border text-black  rounded-r-lg rounded-bl-lg shadow-md',
          ]"
        >
          {{ msg?.text }}
        </div>
        <div
          v-if="msg.table && msg.table.length"
          class="mt-2 group border border-gray-400 relative w-[98%] rounded-md overflow-hidden shadow-sm bg-white"
        >
          <div
            @click="openFullTable(msg)"
            class="hidden group-hover:block absolute top-2 right-2 bg-white rounded-md p-2 border cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
              />
            </svg>
          </div>
          <div class="overflow-x-auto rounded-md">
            <table class="text-xs border text-black border-gray-400 w-full">
              <!-- HEADER -->
              <thead class="bg-gray-100">
                <tr>
                  <th
                    v-for="col in msg.columns"
                    :key="col"
                    class="px-2 py-1 border whitespace-nowrap"
                  >
                    {{ col }}
                  </th>
                </tr>
              </thead>

              <!-- BODY -->
              <tbody>
                <tr v-for="(row, i) in msg.table" :key="i">
                  <td
                    v-for="col in msg.columns"
                    :key="col"
                    class="px-2 py-1 border whitespace-nowrap"
                  >
                    {{ formatCell(row[col]) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="sending" class="flex w-full items-center justify-start">
        <div
          class="flex gap-x-0.5 px-3 py-2 rounded-r-lg rounded-bl-lg text-sm w-fit bg-blue-500 text-white"
        >
          <div v-for="i in 3" :key="i">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="9px"
              viewBox="0 0 24 24"
              width="9px"
              fill="#FFFFFF"
              :style="{ animationDelay: `${0.1 * i}s` }"
              class="animate-bounce"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Input -->
    <div class="p-3 border-t bg-white relative">
      <div
        class="absolute rounded-t-lg flex items-center text-start transition-all ease-in-out duration-300 px-2 text-wrap left-0 right-0 text-gray-50 font-semibold text-sm"
        :class="[
          chatError
            ? 'h-10 bg-[#C0442E] opacity-1 -top-9'
            : 'h-0 bg-transparent opacity-0 top-0',
        ]"
      >
        {{ chatError }}
      </div>
      <div class="flex gap-2">
        <textarea
          ref="textAreaRef"
          v-model="input"
          @input="autoResize"
          @click="autoResize"
          @keydown.enter.exact.stop
          placeholder="Type a message..."
          rows="1"
          class="flex-1 border focus:border-blue-500 rounded-lg px-3 py-2.5 text-sm outline-none resize-none max-h-40 w-full"
        ></textarea>
        <button
          @click="sendMessage"
          class="text-white px-4 rounded-lg text-sm max-h-9"
          :class="[
            input.length
              ? 'bg-blue-600 cursor-pointer'
              : 'bg-blue-300 bg-opacity-90 cursor-not-allowed',
          ]"
        >
          Send
        </button>
      </div>
    </div>
  </div>

  <!-- full size table view -->
  <div
    v-if="showFullTable"
    class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
  >
    <div
      class="bg-white w-[90%] h-[90%] rounded-xl flex flex-col overflow-hidden"
    >
      <!-- Header -->
      <div class="p-4 border-b flex justify-between items-center">
        <h2 class="font-semibold text-lg">Data Table</h2>
        <button
          @click="
            () => {
              showFullTable = false;
              openChatBot = true;
            }
          "
          class="text-gray-500 hover:text-black text-xl"
        >
          ✕
        </button>
      </div>

      <!-- Table -->
      <div class="flex-1 overflow-auto p-4">
        <table class="w-full text-sm border border-gray-300">
          <!-- HEADER -->
          <thead class="bg-gray-100 sticky top-0">
            <tr>
              <th
                v-for="col in fullTable.columns"
                :key="col"
                class="px-3 py-2 border whitespace-nowrap"
              >
                {{ col }}
              </th>
            </tr>
          </thead>

          <!-- BODY -->
          <tbody>
            <tr v-for="(row, i) in fullTable.table" :key="i">
              <td
                v-for="col in fullTable.columns"
                :key="col"
                class="px-3 py-2 border whitespace-nowrap"
              >
                {{ formatCell(row[col]) }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- FALLBACK -->
        <div
          v-if="!fullTable.table || !fullTable.table.length"
          class="text-center text-gray-500 mt-10"
        >
          No data available
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { initializeApp } from "firebase/app";
import axios from "axios";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const store = useStore();
const textAreaRef = ref(null);
const chatError = ref("");
const messages = ref([
  { text: "Hi! How can I help you?", type: "bot", table: [], columns: [] },
]);
const suggestions = ref([
  "How many total leads do we have?",
  "How many leads do we have this month?",
  "Show lead count by all program",
  "Show me monthly payment summary for all months",
  "give me lead details of abc@gmail.com",
]);

const openChatBot = ref(false);
const input = ref("");
const chatBox = ref(null);
const sending = ref(false);

const fullTable = ref(null);
const showFullTable = ref(false);

async function sendMessage() {
  if (!input.value.trim()) return;
  if (sending.value) return;

  messages.value.push({
    text: input.value,
    type: "user",
  });

  sending.value = true;
  const inp = input.value;
  input.value = "";
  nextTick(() => {
    if (textAreaRef.value) {
      textAreaRef.value.style.height = "auto";
    }
  });
  scrollToBottom();

  await axios
    .post(
      `https://cocky-cherry-64090.pktriot.xyz/api/v1/nlsql/ask/`,
      {
        question: inp,
      },
      {
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc1MTk0MTU3LCJpYXQiOjE3NzUxMDc3NTcsImp0aSI6Ijg5NDI5ZjA3Yzc2YzRmZmM4NTc0ZWVmM2M3YWMwMjZmIiwidXNlcl9pZCI6NDkyfQ.I1S-VPUFWYzxWoByRqLggouUma0uW9Nztb9lXY7fv3c`,
        },
      },
    )
    .then((resp) => {
      if (resp.data.success == true) {
        messages.value.push({
          text: resp.data.answer,
          type: "bot",
          table: resp.data.data || [],
          columns: resp.data.columns || [],
        });
        sending.value = false;
        scrollToBottom();
      }
    })
    .catch((error) => {
      console.error("error", error);
      chatError.value =
        error?.response?.data?.message ||
        error?.message ||
        "Please Try again later !!";
      sending.value = false;
    })
    .finally(() => {
      input.value = "";
      if (chatError.value) {
        setTimeout(() => {
          chatError.value = "";
        }, 5000);
      }
    });
}
function handleSuggestionClick(suggestion) {
  if (sending.value) return;
  input.value = suggestion;
  nextTick(() => {
    if (textAreaRef.value) {
      textAreaRef.value.style.height = "auto";
      textAreaRef.value.style.height = textAreaRef.value.scrollHeight + "px";
    }
  });
}
function openFullTable(msg) {
  fullTable.value = msg;
  showFullTable.value = true;
  openChatBot.value = false;
}
function autoResize(e) {
  e.target.style.height = "auto";
  e.target.style.height = e.target.scrollHeight + "px";
}
function scrollToBottom() {
  nextTick(() => {
    if (chatBox.value) {
      chatBox.value.scrollTop = chatBox.value.scrollHeight;
    }
  });
}
function formatCell(value) {
  if (value === null || value === undefined) return "Null";
  return value;
}
const initFirebase = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyCDMMWBZtD-N1zSEuzbUYzsllSFVWk6H14",
    authDomain: "chadura-crm-fe259.firebaseapp.com",
    projectId: "chadura-crm-fe259",
    storageBucket: "chadura-crm-fe259.appspot.com",
    messagingSenderId: "83440943839",
    appId: "1:83440943839:web:e1c825f876ced21f885f6a",
  };

  try {
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    if (!("serviceWorker" in navigator)) {
      console.warn("Service workers are not supported");
      return;
    }

    navigator.serviceWorker.register("/firebase-messaging-sw.js");

    // Foreground messages
    onMessage(messaging, (payload) => {
      console.info("Message received:", payload);

      // Vuex action
      store.dispatch("getNotificationCount");
    });

    // Get FCM token
    getToken(messaging, {
      vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
    })
      .then((token) => {
        if (token) {
          localStorage.setItem("message_token", token);
        }
      })
      .catch((err) => {
        console.error("Token error:", err);
      });
  } catch (error) {
    console.error("Firebase initialization error:", error);
  }
};

onMounted(() => {
  initFirebase();
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
}
</style>
